import LzCrudModel from "../../../../../models/crud";

export const crudConfig = new LzCrudModel({
    ident: 'media',
    baseRoute: '/system/media',
});
